import { isEmpty } from 'lodash';
import { createRouter, createWebHistory } from 'vue-router';
import type { RouteLocationNormalized, RouteRecordRaw } from 'vue-router';

import { currentStepRoute, routes } from '@/router';
import { useUserStore } from '@/stores';

type RoutesKeys = keyof typeof routes;

const routesList: RouteRecordRaw[] = [];
for (const route in routes) {
  const routeRecord = routes[route as RoutesKeys] as RouteRecordRaw;
  routesList.push(routeRecord);
}

const router = createRouter({
  history: createWebHistory(),
  routes: routesList as RouteRecordRaw[]
});

/* Navigation guard */
router.beforeEach((to: RouteLocationNormalized) => {
  const requireAuth = to.meta.requireAuth ?? false;
  const { user: currentUser } = useUserStore();
  const isAuthPath = [routes.login.name].includes(to.name as string);

  if (requireAuth && isEmpty(currentUser)) {
    return { name: routes.login.name };
  } else if (isAuthPath && !isEmpty(currentUser)) {
    /* Prevent access to login route if user is already logged */
    return currentStepRoute(currentUser);
  }
});

export default router;
